import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

import ConfirmModalMUI from '../warehouse/modals/ConfirmModalMUI';
import FeedbackModalMUI from '../warehouse/modals/FeedbackModalMUI';
const countries = [
  { code: 'AL', label: 'Albânia – AL' },
  { code: 'AD', label: 'Andorra – AD' },
  { code: 'AM', label: 'Arménia – AM' },
  { code: 'AT', label: 'Áustria – AT' },
  { code: 'AZ', label: 'Azerbaijão – AZ' },
  { code: 'BY', label: 'Bielorrússia – BY' },
  { code: 'BE', label: 'Bélgica – BE' },
  { code: 'BA', label: 'Bósnia e Herzegovina – BA' },
  { code: 'BG', label: 'Bulgária – BG' },
  { code: 'HR', label: 'Croácia – HR' },
  { code: 'CY', label: 'Chipre – CY' },
  { code: 'CZ', label: 'República Tcheca – CZ' },
  { code: 'DK', label: 'Dinamarca – DK' },
  { code: 'EE', label: 'Estónia – EE' },
  { code: 'FI', label: 'Finlândia – FI' },
  { code: 'FR', label: 'França – FR' },
  { code: 'GE', label: 'Geórgia – GE' },
  { code: 'DE', label: 'Alemanha – DE' },
  { code: 'GR', label: 'Grécia – GR' },
  { code: 'HU', label: 'Hungria – HU' },
  { code: 'IS', label: 'Islândia – IS' },
  { code: 'IE', label: 'Irlanda – IE' },
  { code: 'IT', label: 'Itália – IT' },
  { code: 'LV', label: 'Letónia – LV' },
  { code: 'LI', label: 'Liechtenstein – LI' },
  { code: 'LT', label: 'Lituânia – LT' },
  { code: 'LU', label: 'Luxemburgo – LU' },
  { code: 'MT', label: 'Malta – MT' },
  { code: 'MD', label: 'Moldávia – MD' },
  { code: 'MC', label: 'Mónaco – MC' },
  { code: 'ME', label: 'Montenegro – ME' },
  { code: 'NL', label: 'Países Baixos (Holanda) – NL' },
  { code: 'MK', label: 'Macedónia do Norte – MK' },
  { code: 'NO', label: 'Noruega – NO' },
  { code: 'PL', label: 'Polónia – PL' },
  { code: 'PT', label: 'Portugal – PT' },
  { code: 'RO', label: 'Roménia – RO' },
  { code: 'RU', label: 'Rússia – RU' },
  { code: 'SM', label: 'San Marino – SM' },
  { code: 'RS', label: 'Sérvia – RS' },
  { code: 'SK', label: 'Eslováquia – SK' },
  { code: 'SI', label: 'Eslovénia – SI' },
  { code: 'ES', label: 'Espanha – ES' },
  { code: 'SE', label: 'Suécia – SE' },
  { code: 'CH', label: 'Suíça – CH' },
  { code: 'TR', label: 'Turquia – TR' },
  { code: 'UA', label: 'Ucrânia – UA' },
  { code: 'GB', label: 'Reino Unido – GB' },
  { code: 'VA', label: 'Cidade do Vaticano (Santa Sé) – VA' }
];

const AddMoradaModal = ({ open, onClose, onSubmit }) => {
  const [defenicao, setDefenicao] = useState('');
  const [nomePessoaEntregar, setNomePessoaEntregar] = useState('');
  const [address, setAddress] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [country, setCountry] = useState('');
  const [city, setCity] = useState('');
  const [deliveryname, setDeliveryname] = useState('');
  const [mobilephone, setMobilephone] = useState('');
  const [phone, setPhone] = useState('');
  const [mail, setMail] = useState('');
  const [suplementInformation, setSuplementInformation] = useState('');
  const [textsetiquetas, setTextsetiquetas] = useState('');

  // Handle address overflow into suplementInformation
  const handleAddressChange = (e) => {
    const value = e.target.value;
    if (value.length <= 30) {
      setAddress(value);
    } else {
      // Keep first 30 chars in address
      setAddress(value.slice(0, 30));
      // Push overflow into suplementInformation, preserving any existing text
      const overflow = value.slice(30);
      setSuplementInformation(prev => overflow + prev);
    }
  };

  const [showDelivery, setShowDelivery] = useState(false);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionComplete, setSubmissionComplete] = useState(false);
  const [error, setError] = useState(null);
  const [feedbackMessage, setFeedbackMessage] = useState('');

  const buildPayload = () => ({
    defenicao,
    nome_pessoa_entregar: nomePessoaEntregar,
    address,
    postal_code: postalCode,
    country,
    city,
    ...(showDelivery ? { deliveryname, mobilephone, phone, mail } : {}),
    suplementinformation: suplementInformation,
    textsetiquetas,
  });

  // Abre modal de confirmação, resetando estados de feedback
  const handleAddClick = () => {
    setSubmissionComplete(false);
    setError(null);
    setFeedbackMessage('');
    setConfirmOpen(true);
  };

 
  const handleConfirm = () => {
    setConfirmOpen(false);
    setFeedbackOpen(true);
    setIsSubmitting(true);
    setSubmissionComplete(false);
    setError(null);
  
    const payload = buildPayload();
  
    Promise.resolve()
      .then(() => onSubmit(payload))
      .then(resMessage => {
        setIsSubmitting(false);
        setSubmissionComplete(true);
        setFeedbackMessage(resMessage || 'Morada adicionada com sucesso.');
      })
      .catch(err => {
        setIsSubmitting(false);
        setSubmissionComplete(false);
  
        // Se veio um erro do Axios com response.data, extrai os detalhes:
        let message = 'Erro ao adicionar morada.';
        const data = err.response?.data;
        if (data && typeof data === 'object') {
          // mapeia cada campo e junta as mensagens
          message = Object.entries(data)
            .map(([field, msgs]) => {
              // msgs pode ser array de strings ou objeto aninhado
              const text = Array.isArray(msgs)
                ? msgs.join(', ')
                : typeof msgs === 'object'
                  ? JSON.stringify(msgs)
                  : String(msgs);
              return `${field}: ${text}`;
            })
            .join('\n');
        } else if (err.message) {
          message = err.message;
        }
  
        setError(message);
      });
  };
  const handleFeedbackClose = () => {
    setFeedbackOpen(false);
    if (submissionComplete) {
      onClose();
    }
  };


  return (
    <>
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Adicionar Morada</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate sx={{ mt: 1 }}>
          <TextField
            margin="dense"
            label="Defenicao"
            placeholder="Aqui colocas 'sede' ou o nome do trabalho por exemplo"
            fullWidth
            value={defenicao}
            onChange={(e) => setDefenicao(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Nome da empresa ou o nome da pessoa a entregar"
            fullWidth
            value={nomePessoaEntregar}
            onChange={(e) => setNomePessoaEntregar(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Address"
            fullWidth
            value={address}
            onChange={handleAddressChange}
          />
          <TextField
            margin="dense"
            label="Informação adicional"
            placeholder="Informação adicional"
            fullWidth
            inputProps={{ maxLength: 30 }}
            value={suplementInformation}
            onChange={(e) => setSuplementInformation(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Postal Code"
            fullWidth
            value={postalCode}
            onChange={(e) => setPostalCode(e.target.value)}
          />
          {/* Dropdown para selecionar País */}
          <FormControl fullWidth margin="dense">
            <InputLabel id="country-label">País</InputLabel>
            <Select
              labelId="country-label"
              label="País"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
            >
              {countries.map((item) => (
                <MenuItem key={item.code} value={item.code}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/* Campo City: Sempre exibido para que o usuário digite, caso necessário */}
          <TextField
            margin="dense"
            label="City"
            placeholder='cidade do codigo postal por exemplo "Griñón"'
            fullWidth
            inputProps={{ maxLength: 15 }}
            value={city}
            onChange={(e) => setCity(e.target.value)}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={showDelivery}
                onChange={(e) => setShowDelivery(e.target.checked)}
              />
            }
            label="Informações para a notificação de entrega"
          />
          {/* Renderiza os campos de entrega somente se showDelivery estiver marcado */}
          {showDelivery && (
            <>
              <TextField
                margin="dense"
                label="Delivery Name"
                placeholder="Nome da pessoa que irá recolher"
                fullWidth
                value={deliveryname}
                onChange={(e) => setDeliveryname(e.target.value)}
              />
              <TextField
                margin="dense"
                label="Mobile Phone"
                fullWidth
                value={mobilephone}
                onChange={(e) => setMobilephone(e.target.value)}
              />
              <TextField
                margin="dense"
                label="Phone"
                fullWidth
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              <TextField
                margin="dense"
                label="Mail"
                type="email"
                fullWidth
                value={mail}
                onChange={(e) => setMail(e.target.value)}
              />
            </>
          )}
          
          <TextField
            margin="dense"
            label="Texto para Etiquetas"
            placeholder="Introduz aqui o que queres que apareça na etiqueta"
            fullWidth
            value={textsetiquetas}
            onChange={(e) => setTextsetiquetas(e.target.value)}
          />
        </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button onClick={handleAddClick} variant="contained">Adicionar</Button>
        </DialogActions>
      </Dialog>

      <ConfirmModalMUI
        open={confirmOpen}
        message="Deseja realmente adicionar esta morada?"
        onConfirm={handleConfirm}
        onCancel={() => setConfirmOpen(false)}
      />

    <FeedbackModalMUI
            open={feedbackOpen}
            isSubmitting={isSubmitting}
            submissionComplete={submissionComplete}
            error={error}
            feedbackMessage={feedbackMessage}
            onClose={handleFeedbackClose}
          />
    </>
  );
};

export default AddMoradaModal;
